import { Injectable } from '@angular/core';

import { AccountBalanceLoggerService, AccountBalanceService } from '@frontend/sports/account-balance/feature';
import { UserService } from '@frontend/sports/user/feature';
import { Decimal } from 'decimal.js';

import { IBetslip } from '../../../../bet-generation/models';
import { isBetStationFreebetToken } from '../../../../reward-tokens/services/betstation-reward-tokens.utils';
import { isFreebetToken } from '../../../../reward-tokens/services/reward-tokens.utils';
import { InsufficientFundsPreCheckError } from '../../../errors/pre-check/insufficient-funds-pre-check-error';
import { BetslipValidationContext } from '../../../models/models';
import { IContextBetslipValidator } from './validators';

@Injectable()
export class InsufficientFundsValidator implements IContextBetslipValidator<InsufficientFundsPreCheckError> {
    constructor(
        private userService: UserService,
        private accountBalanceService: AccountBalanceService,
        private logger: AccountBalanceLoggerService,
    ) {}

    validate(betslip: IBetslip, context: BetslipValidationContext): InsufficientFundsPreCheckError[] {
        if (!this.userService.isAuthenticated) {
            return [];
        }

        if (betslip.slips.every((slip) => slip.stake === null || isFreebetToken(slip.rewardToken) || isBetStationFreebetToken(slip.rewardToken))) {
            return [];
        }

        const stake = this.getTotalStake(betslip, context);
        const balance = this.getBalance();

        if (stake.greaterThan(balance)) {
            return [new InsufficientFundsPreCheckError(balance, stake.toNumber())];
        }

        return [];
    }

    protected getBalance(): number {
        this.logger.setLastValidatedBalance(this.accountBalanceService.currentBalanceAmount);

        return this.accountBalanceService.currentBalanceAmount;
    }

    private getTotalStake(betslip: IBetslip, context: BetslipValidationContext): Decimal {
        if (context.editBet) {
            return new Decimal(context.editBet.addedStake);
        }

        return new Decimal(
            betslip.slips.reduce((acc, slip) => acc + (slip.stake && !isFreebetToken(slip.rewardToken) ? slip.stake * slip.bets.length : 0), 0),
        );
    }
}
